import { render } from "./Delcode2StudyStaff.vue?vue&type=template&id=68fc4c56&scoped=true"
import script from "./Delcode2StudyStaff.vue?vue&type=script&lang=js"
export * from "./Delcode2StudyStaff.vue?vue&type=script&lang=js"

import "./Delcode2StudyStaff.vue?vue&type=style&index=0&id=68fc4c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fc4c56"]])

export default __exports__